import { Badge, Table } from 'react-bootstrap';

import type { FiscalYearPreview } from 'utils/fiscalPeriods';

interface Props {
  readonly years: readonly FiscalYearPreview[];
  readonly selectedYear: number;
}

/** Compact table of fiscal-year start/end/length for the preview range. */
export const FiscalYearTable = ({ years, selectedYear }: Props) => (
  <Table size="sm" hover className="mb-3">
    <thead>
      <tr>
        <th>FY</th>
        <th>Period 1 starts</th>
        <th>Year ends</th>
        <th>Length</th>
      </tr>
    </thead>
    <tbody>
      {years.map((y) => (
        <tr key={y.year} className={y.year === selectedYear ? 'table-active' : undefined}>
          <td>
            {y.year}
            {y.weeks === 53 ? (
              <Badge bg="warning" text="dark" className="ms-2">
                53w
              </Badge>
            ) : null}
          </td>
          <td className="font-monospace">{y.start}</td>
          <td className="font-monospace">{y.end}</td>
          <td>
            {y.weeks} weeks ({y.weeks * 7} days)
          </td>
        </tr>
      ))}
    </tbody>
  </Table>
);
